import { createSelector } from 'reselect'
import { RootState } from 'redux/root-reducer'

const selectAlert = (state: RootState) => state.alert

export const selectAlertPack = createSelector([selectAlert], (alert) => alert)
